import { Permission } from 'shared'
import RPTQuickLinksTable from '../../../../../../../components/CIMSTable/common/components/RPTQuickLinksTable'
import {
  useCreateRfiQuickLinkMutation,
  useEditRfiQuickLinkMutation,
  useGetRfiQuickLinksQuery,
  useRestoreRfiQuickLinkMutation,
  useSoftRemoveRfiQuickLinkMutation,
} from '../../../../../../../schema'

const RFIQuickLinks: React.FC = () => (
  <RPTQuickLinksTable
    query={useGetRfiQuickLinksQuery}
    entity="Request For Information"
    getQuickLinks={(data) => data?.rfiQuickLinks?.records ?? []}
    create={{
      permission: Permission.CreateRFIQuickLink,
      mutation: useCreateRfiQuickLinkMutation,
      getLabel: ({ createRFIQuickLink: create }) => create.rfiQuickLink,
    }}
    edit={{
      permission: Permission.EditRFIQuickLink,
      mutation: useEditRfiQuickLinkMutation,
      getLabel: ({ editRFIQuickLink: edit }) => edit.rfiQuickLink,
    }}
    remove={{
      permission: Permission.RemoveRestoreRFIQuickLink,
      mutation: useSoftRemoveRfiQuickLinkMutation,
      getLabel: ({ softRemoveRFIQuickLink: remove }) => remove.rfiQuickLink,
    }}
    restore={{
      permission: Permission.RemoveRestoreRFIQuickLink,
      mutation: useRestoreRfiQuickLinkMutation,
      getLabel: ({ restoreRFIQuickLink: restore }) => restore.rfiQuickLink,
    }}
  />
)

export default RFIQuickLinks
